import store from "../store/store";
import Cookies from "js-cookie";
import * as Actions from "../store/actions/global/global";
import * as ActionsBilling from "../store/actions/billing/billing";
import * as ActionsInvoice from "../store/actions/billing/invoiceHistoryActions";
import * as ActionsPayment from "../store/actions/billing/paymentHistoryAction";
import { getRefreshTokenCall } from "../api/user";
import {
  REDBALL_FEATURE_TOGGLE,
  DEVLOCALDOMAIN,
  DEVDOMAIN,
  QADOMAIN,
  STAGEUSDOMAIN,
  STAGEEUDOMAIN,
  PRODUSDOMAIN,
  PRODEUDOMAIN,
  suspendedFinancialStatuses,
} from "../constants/appConstants";

let requested = null;

export default async function refreshToken() {
  if (requested !== null) return requested;
  let baseheaders = headerAuthbase();
  let header = {
    headers: {
      ...baseheaders,
      "X-APILOGS-KEY": "vccpzax9bzdw7log",
    },
  };
  let reqBody = {
    refreshToken: localStorage.getItem("refresh_token"),
    userId: store.getState().ACCOUNT.userId,
  };
  requested = getRefreshTokenCall(header, reqBody)
    .then((response) => {
      if (response?.data?.statusCode === "200") {
        Cookies.set("tkauth", response?.data?.data?.accessToken);
        if (response?.data?.data?.refreshToken) {
          localStorage.setItem("refresh_token", response?.data?.data?.refreshToken);
        }
        store.dispatch(Actions.setEncryptId(response?.data?.data?.decryptValue));
        requested = null;
        return response;
      } else {
        store.dispatch(Actions.setSessionExpired(true));
        requested = null;
        return Promise.reject(response);
      }
    })
    .catch((response) => {
      store.dispatch(Actions.setSessionExpired(true));
      requested = null;
      return Promise.reject(response);
    });
  return requested;
}

export async function interceptor(func) {
  updateNewRelicStats();
  return func().catch(async (response) => {
    if (response.response.status === 401) {
      //START - REDBALL CONFIG
      if (REDBALL_FEATURE_TOGGLE) {
        if (checkImpersonateUser()) {
          if (localStorage.getItem("refresh_token")) {
            await refreshToken();
            return await func();
          } else {
            store.dispatch(Actions.setSessionExpired(true));
            Cookies.set("customerPortalSessionExpired", true);
            return Promise.reject(response);
          }
        } else {
          store.dispatch(Actions.setSessionExpired(true));
          // we need to look into it
          Cookies.set("customerPortalSessionExpired", true);
          return Promise.reject(response);
        }
      } else if (localStorage.getItem("refresh_token")) {
          await refreshToken();
          return await func();
        } else {
          store.dispatch(Actions.setSessionExpired(true));
          Cookies.set("customerPortalSessionExpired", true);
          return Promise.reject(response);
      }
      //END - REDBALL CONFIG
    } else {
      return Promise.reject(response);
    }
  });
}

export async function encryptor(data) {
  const ivString = store.getState().ACCOUNT.encrypId;
  const ivArray = new Uint8Array(ivString.length);
  for (let i = 0; i < ivString.length; i++) {
    ivArray[i] = ivString.charCodeAt(i);
  }
  const iv = ivArray.buffer;
  const keyMaterial = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(store.getState().ACCOUNT.encrypId));
  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    keyMaterial,
    {
      name: "AES-GCM",
      length: 256,
    },
    false,
    ["encrypt"]
  );
  const encodedData = new TextEncoder().encode(data);
  const algorithm = { name: "AES-GCM", iv };
  const bufferToBase64 = (buffer) => btoa(String.fromCharCode(...new Uint8Array(buffer)));
  try {
    const encryptVal = await window.crypto.subtle.encrypt(algorithm, cryptoKey, encodedData);
    const base64Result = bufferToBase64(encryptVal);
    return base64Result;
  } catch (error) {
    console.error('Encryption failed:', error);
    return null;
  }
}
const account = ["accId", "accountId", "contactId", "contractId", "contractAccountID", "contractAccountNumber", "contractAccountId"];
const billing = ["contractAccount", "invoiceNumber", "businessPartnerId", "contractAccountId", "actionCode", "customerUserId"];
const user = ["accountNo", "contractNumber", "userId"];
const cases = ["accountNo", "caseId", "accountId", "contactId"];
const schedule = ["accountId", "contractAccountId", "contractAccount"];
//regions with regionId//
// IRL:372
// FRA:250
// DEU:276
// NLD:528
// UK:826
// US:840
// CAN:124
// AUS:36
// NZ:554
const keys = new Set([...account, ...billing, ...user, ...cases, ...schedule]);
const scheduleKeys = new Set([...schedule]);
async function substituteListHelper(list, context = null) {
  for (let i = 0; i < list.length; i++) {
    // for REDBALL encrypting the array values for getPaymentStatusApiCall alone.
    if (REDBALL_FEATURE_TOGGLE && context === "getPaymentStatusApiCall" && typeof list[i] === "string") {
      list[i] = await encryptor(list[i]);
    } else {
      await substituteEncrypted1(list[i]);
    }
  }
}

export async function substituteEncrypted(data, context = null) {
  data = JSON.parse(JSON.stringify(data));
  for (const dataKey in data) {
    if (Array.isArray(data[dataKey])) {
      await substituteListHelper(data[dataKey], context);
    } else if (keys.has(dataKey)) {
        data[dataKey] = await encryptor(data[dataKey]);
    }
  }
  return data;
}

async function substituteEncrypted1(data) {
  for (const dataKey in data) {
    if (Array.isArray(data[dataKey])) {
      await substituteListHelper(data[dataKey]);
    } else if (keys.has(dataKey)) {
      data[dataKey] = await encryptor(data[dataKey]);
    }
  }
  return data;
}

async function substituteScheduleListHelper(list) {
  for (const listElement of list) {
    await substituteScheduleEncrypted1(listElement);
  }
}

export async function substituteScheduleEncrypted(data) {
  data = JSON.parse(JSON.stringify(data));
  for (const dataKey in data) {
    if (Array.isArray(data[dataKey])) {
      await substituteScheduleListHelper(data[dataKey]);
    } else if (scheduleKeys.has(dataKey)) {
        data[dataKey] = await encryptor(data[dataKey]);
    } else if (dataKey === "Body") {
        await substituteScheduleEncrypted1(data.Body);
    }
  }
  return data;
}

async function substituteScheduleEncrypted1(data) {
  for (const dataKey in data) {
    if (Array.isArray(data[dataKey])) {
      await substituteScheduleListHelper(data[dataKey]);
    } else if (scheduleKeys.has(dataKey)) {
        data[dataKey] = await encryptor(data[dataKey]);
    }
  }
  return data;
}

const formatter = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 });

export function currencyFormatter(currencyValue) {
  if (currencyValue === "" || currencyValue === undefined || currencyValue === null || isNaN(currencyValue)) {
    return "";
  } else {
    return formatter.format(currencyValue);
  }
}

export function getAlertState() {
  return sessionStorage.getItem("isAlertModalVisible") === "true";
}

export function setAlertState(state) {
  sessionStorage.setItem("isAlertModalVisible", state);
}

export function resetRedux() {
  store.dispatch(Actions.reset());
  store.dispatch(ActionsBilling.reset());
  store.dispatch(ActionsInvoice.reset());
  store.dispatch(ActionsPayment.reset());
  detectSize();
}

const detectSize = () => {
  store.dispatch(
    Actions.setwindowWidthHeight({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  );
};

export function updateNewRelicStats() {
  if (window.newrelic) {
    window.newrelic.interaction().setAttribute("userId", store.getState().ACCOUNT.userId);
  }
}
export function updateNewRelicStatsFromSession() {
  // Get the current Redux state directly from the store
  const state = store.getState();
  if (state) {
    window.newrelic.setCustomAttribute("userId", state.ACCOUNT.userId);
    if (state.ACCOUNT?.accountUserTokenDetails) {
        window.pendo?.initialize({
          visitor: {
            id: state.ACCOUNT.accountUserTokenDetails.rowGuId,
            lang: state.ACCOUNT.accountUserTokenDetails.userLanguage,
          },
          account: {
            id: state.ACCOUNT.accountUserTokenDetails.accountId,
            regionId: state.ACCOUNT.accountUserTokenDetails.accountRegionId,
            lang: state.ACCOUNT.accountUserTokenDetails.userLanguage,
            universalAccountId: state.ACCOUNT.accountUserTokenDetails.universalAccountId,
          },
        });
    }
  }
}

export const setDomain = (domain) => {
  switch (domain) {
    case "connectcustomerportal-uat.verizon.com":
      return "reveal.stage.us.fleetmatics.com";
    case "connectcustomerportal.verizon.com":
      return "reveal.us.fleetmatics.com";
    case "vccp-uat.ebiz.verizon.com":
      return "reveal.stage.us.fleetmatics.com";
    case "vccp-dev.ebiz.verizon.com":
      return "dev.development.fleetmatics.com";
    case "vccp-qa.ebiz.verizon.com":
      return "test.us.development.fleetmatics.com";
    // vzconnect.com domain mappings
    case "reveal.stage.us.vzconnect.com":
      return "reveal.stage.us.vzconnect.com";
    case "reveal.us.vzconnect.com":
      return "reveal.us.vzconnect.com";
    case "reveal.stage.eu.vzconnect.com":
      return "reveal.stage.eu.vzconnect.com";
    case "reveal.eu.vzconnect.com":
      return "reveal.eu.vzconnect.com";
    default:
      return domain;
  }
};

export const firstNameLastName = (contact) => {
  let name = "--";
  if (contact?.contactFirstName && contact?.contactLastName) {
    name = `${contact.contactFirstName} ${contact.contactLastName}`;
  } else if (contact?.contactFirstName) {
    name = contact.contactFirstName;
  } else if (contact?.contactLastName) {
    name = contact.contactLastName;
  }
  return name;
};

export const getDomainLocation = () => {
  let windowLocation = window.location.host;
  let domain;
  if (DEVLOCALDOMAIN.includes(windowLocation)) {
    domain = "local";
  } else if (DEVDOMAIN.includes(windowLocation)) {
    domain = "dev";
  } else if (QADOMAIN.includes(windowLocation)) {
    domain = "qa";
  } else if (STAGEUSDOMAIN.includes(windowLocation)) {
    domain = "stageUS"; //for stage US
    // domain = "stageUSAuthDomain"; //for auth0 US stage
  } else if (STAGEEUDOMAIN.includes(windowLocation)) {
    domain = "stageEU"; // for stage EU
    // domain = "stageEUAuthDomain"; //for auth0 EU stage
  } else if (PRODUSDOMAIN.includes(windowLocation)) {
    domain = "us";
  } else if (PRODEUDOMAIN.includes(windowLocation)) {
    domain = "eu";
  } else {
    domain = "local";
  }
  return domain;
};

export const checkNonQADomain = () => {
  let domain = getDomainLocation();
  let QAdomain = false;
  if (domain !== "qa") {
    QAdomain = true;
  }
  return QAdomain;
};

export const hasContractAccountDetails = (erpBusinessPartner, contractAccount) => {
  return (
    erpBusinessPartner.data?.contractAccountDetails?.some(
      (item) => suspendedFinancialStatuses.includes(item.financialStatus?.toLowerCase()) && item.erpCANumber === contractAccount
    )
  );
};

export const checkImpersonateUser = () => {
  const tkauth = Cookies.get("tkauth");
  const fleetcarebackurl = Cookies.get("fleetcarebackurl");
  return !!(tkauth && fleetcarebackurl);
};

export const getTokenType = () => {
  const tkauth = Cookies.get("tkauth");
  const fleetcarebackurl = Cookies.get("fleetcarebackurl");
  return tkauth && fleetcarebackurl ? "tkauth" : "cptoken";
};

export const getImpersonateToken = () => {
  return checkImpersonateUser() ? Cookies.get("tkauth") : Cookies.get("cptoken");
};

export const getTheToken = () => {
  return REDBALL_FEATURE_TOGGLE ? getImpersonateToken() : Cookies.get("tkauth");
};

export const removeImpersonateToken = () => {
  checkImpersonateUser() ? Cookies.remove("tkauth") : Cookies.remove("cptoken");
};

export const removeTheToken = () => {
  REDBALL_FEATURE_TOGGLE ? removeImpersonateToken() : Cookies.remove("tkauth");
};

export const getAuthHeader = (revealHeader) => {
  let headersbase = headerAuthbase();
  return revealHeader ? { headers: { ...revealHeader, ...headersbase } } : { headers: { ...headersbase } };
};

export const headerAuthbase = () => {
  let headersbase = {
    "Reveal-Authorization": getTheToken(),
    domain: setDomain(window.location.host),
  };
  if (REDBALL_FEATURE_TOGGLE) {
    headersbase["token-type"] = getTokenType();
  }
  return headersbase;
};

export const getRegion = () => {
  const {isAPAC, isEMEA, isNA} = store.getState().ACCOUNT.accountUserTokenDetails;
  return { isAPAC, isEMEA, isNA };
};